/**
 * Recharge bundle cart: one row per bundle in drawer and main cart.
 * - Remove bundle: set all bundle line items to quantity 0 via cart/update.js
 * - Change bundle quantity: set all bundle line items to same quantity via cart/update.js
 */
(function () {
  if (typeof window.routes === 'undefined' || !window.routes.cart_update_url) return;

  function getBundleIndicesFromRow(inputOrButton) {
    const row = inputOrButton.closest('[data-bundle-indices]');
    if (!row) return null;
    const raw = row.getAttribute('data-bundle-indices');
    if (!raw) return null;
    return raw.split(',').map((s) => s.trim()).filter(Boolean);
  }

  function isInDrawer(el) {
    return el && el.closest('cart-drawer-items');
  }

  function applySections(data, inDrawer) {
    if (inDrawer && data.sections && data.sections['cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
      const targetItems = document.querySelector('cart-drawer-items');
      const sourceItems = doc.querySelector('cart-drawer-items');
      const targetFooter = document.querySelector('.cart-drawer__footer');
      const sourceFooter = doc.querySelector('.cart-drawer__footer');
      if (targetItems && sourceItems) targetItems.replaceWith(sourceItems);
      if (targetFooter && sourceFooter) targetFooter.replaceWith(sourceFooter);
      return;
    }
    if (!inDrawer && data.sections) {
      const mainCartEl = document.getElementById('main-cart-items');
      const sectionId = mainCartEl && mainCartEl.dataset && mainCartEl.dataset.id ? mainCartEl.dataset.id : 'main-cart-items';
      if (data.sections[sectionId]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data.sections[sectionId], 'text/html');
        const newContents = doc.querySelector('.js-contents');
        const target = document.querySelector('#main-cart-items .js-contents');
        if (target && newContents) target.innerHTML = newContents.innerHTML;
        return;
      }
    }
    if (inDrawer) {
      fetch(window.routes.cart_url + '?section_id=cart-drawer')
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          ['cart-drawer-items', '.cart-drawer__footer'].forEach((sel) => {
            const t = document.querySelector(sel);
            const s = doc.querySelector(sel);
            if (t && s) t.replaceWith(s);
          });
        })
        .catch((e) => console.error(e));
    } else {
      const mainCartEl = document.getElementById('main-cart-items');
      const sectionId = mainCartEl && mainCartEl.dataset && mainCartEl.dataset.id ? mainCartEl.dataset.id : 'main-cart-items';
      fetch(window.routes.cart_url + '?section_id=' + sectionId)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newContents = doc.querySelector('.js-contents');
            const target = document.querySelector('#main-cart-items .js-contents');
            if (target && newContents) target.innerHTML = newContents.innerHTML;
          })
          .catch((e) => console.error(e));
    }
  }

  function updateBundleLines(updates, inDrawer) {
    const mainEl = document.getElementById('main-cart-items');
    const sections = inDrawer ? 'cart-drawer' : (mainEl && mainEl.dataset && mainEl.dataset.id ? mainEl.dataset.id : 'main-cart-items');
    const body = JSON.stringify({
      updates: updates,
      sections: sections,
      sections_url: window.location.pathname,
    });
    return fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    })
      .then((res) => res.json())
      .then((data) => {
        applySections(data, inDrawer);
      })
      .catch((e) => {
        console.error(e);
        applySections(null, inDrawer);
      });
  }

  document.addEventListener(
    'click',
    (e) => {
      const removeBtn = e.target.closest('cart-remove-button');
      if (!removeBtn) return;
      const indices = removeBtn.getAttribute('data-bundle-indices');
      if (!indices) return;
      e.preventDefault();
      e.stopPropagation();
      const updates = {};
      indices.split(',').forEach((i) => {
        updates[i.trim()] = 0;
      });
      const inDrawer = isInDrawer(removeBtn);
      updateBundleLines(updates, inDrawer);
    },
    true
  );

  document.addEventListener(
    'change',
    (e) => {
      if (!e.target.matches || !e.target.matches('.quantity__input')) return;
      const indices = getBundleIndicesFromRow(e.target);
      if (!indices || indices.length <= 1) return;
      const qty = parseInt(e.target.value, 10);
      if (isNaN(qty) || qty < 0) return;
      e.stopImmediatePropagation();
      const updates = {};
      indices.forEach((i) => {
        updates[i] = qty;
      });
      const inDrawer = isInDrawer(e.target);
      updateBundleLines(updates, inDrawer);
    },
    true
  );
})();
